/**
 * Validates a phone number is in E.164 format.
 */
export function isValidE164(phoneNumber: string): boolean {
  return /^\+[1-9]\d{1,14}$/.test(phoneNumber);
}

/**
 * Formats a UK phone number input to E.164 format.
 *
 * Handles common UK formats:
 * - 07xxx xxxxxx → +447xxxxxxxxx
 * - +447xxxxxxxxx → +447xxxxxxxxx (passthrough)
 */
export function formatToE164(input: string): string {
  let cleaned = input.replace(/\s/g, "");

  if (cleaned.startsWith("0")) {
    cleaned = "+44" + cleaned.slice(1);
  }

  if (!cleaned.startsWith("+") && cleaned.length > 0) {
    cleaned = "+" + cleaned;
  }

  return cleaned;
}
